module.exports = __webpack_public_path__ + "img/1.e7b9f405.jpg";